document.addEventListener('DOMContentLoaded', function() {
  const tierCards = document.querySelectorAll('.editorial-tier-selector .tier-card');
  const buyBtn = document.querySelector('#tagebuch-buy');
  const statusEl = document.querySelector('#tagebuch-status');
  const variantInput = document.querySelector('#tagebuch-variant-id');
  const qtyInput = document.querySelector('#tagebuch-qty-hidden');
  
  if (!buyBtn || !tierCards.length) return;
  
  const price1Text = buyBtn.getAttribute('data-price-1') || '19,89 €';
  const price6Text = buyBtn.getAttribute('data-price-6') || '95,99 €';
  const price12Text = buyBtn.getAttribute('data-price-12') || '179,99 €';
  const maxStock = parseInt(buyBtn.getAttribute('data-stock'), 10) || 0;
  
  let currentQty = 6;
  
  function selectTier(card) {
    if (card.classList.contains('is-disabled')) return;
    const qty = parseInt(card.getAttribute('data-qty'), 10) || 6;
    currentQty = qty;
    if (qtyInput) qtyInput.value = qty;
    
    tierCards.forEach(c => {
      c.classList.remove('is-selected');
      c.setAttribute('aria-checked', 'false');
    });
    
    card.classList.add('is-selected');
    card.setAttribute('aria-checked', 'true');
    
    // Update Buy Button Text
    if (buyBtn.disabled && buyBtn.classList.contains('is-sold-out')) return;
    
    if (qty === 1) {
      buyBtn.textContent = '1 Flasche kaufen · ' + price1Text;
    } else if (qty === 6) {
      buyBtn.textContent = '6er-Weinkiste kaufen · ' + price6Text;
    } else if (qty === 12) {
      buyBtn.textContent = '12 Flaschen kaufen · ' + price12Text;
    }
  }
  
  tierCards.forEach(card => {
    card.addEventListener('click', function() {
      if (!card.classList.contains('is-disabled')) {
        selectTier(card);
      }
    });
    
    card.addEventListener('keydown', function(e) {
      if ((e.key === ' ' || e.key === 'Enter') && !card.classList.contains('is-disabled')) {
        e.preventDefault();
        selectTier(card);
      }
    });
  });
  
  // Set initial state
  const available6 = document.querySelector('.editorial-tier-selector .tier-card[data-qty="6"]:not(.is-disabled)');
  const available1 = document.querySelector('.editorial-tier-selector .tier-card[data-qty="1"]:not(.is-disabled)');
  const defaultCard = available6 || available1;
  
  if (defaultCard && maxStock > 0) {
    selectTier(defaultCard);
  } else {
    // Sold out state
    buyBtn.disabled = true;
    buyBtn.classList.add('is-sold-out');
    buyBtn.textContent = 'Ausverkauft';
    if (qtyInput) qtyInput.value = 0;
  }
  
  // Buy Button Action
  buyBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (buyBtn.disabled || buyBtn.classList.contains('is-sold-out')) {
      return;
    }
    
    const variantId = variantInput ? variantInput.value : '';
    if (!variantId) {
      statusEl.textContent = 'Fehler: Keine Produktvariante ausgewählt.';
      return;
    }
    
    if (currentQty > maxStock) {
      statusEl.textContent = 'Die gewünschte Menge übersteigt den verfügbaren Bestand.';
      return;
    }
    
    buyBtn.disabled = true;
    buyBtn.textContent = 'Wird in den Warenkorb gelegt …';
    statusEl.textContent = '';
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: currentQty,
        properties: {
          '_xboost_offer_id': '295f73f1ed884308ad52bff3ab1b7e49'
        }
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      if (data.status && data.status !== 200) {
        statusEl.textContent = data.description || 'Das hat leider nicht geklappt.';
        buyBtn.disabled = false;
        const currentCard = document.querySelector('.editorial-tier-selector .tier-card.is-selected');
        if (currentCard) selectTier(currentCard);
      } else {
        const itemLabel = currentQty === 1 ? '1 Flasche' : (currentQty === 6 ? '6er-Weinkiste' : '12 Flaschen');
        statusEl.innerHTML = '<strong>' + itemLabel + ' im Warenkorb!</strong>';
        buyBtn.disabled = false;
        buyBtn.textContent = 'Erfolgreich hinzugefügt ✓';
        setTimeout(function() {
          window.location.href = '/cart';
        }, 800);
      }
    })
    .catch(function(err) {
      console.error('Cart add error:', err);
      statusEl.textContent = 'Netzwerkfehler: Bitte versuchen Sie es erneut.';
      buyBtn.disabled = false;
      const currentCard = document.querySelector('.editorial-tier-selector .tier-card.is-selected');
      if (currentCard) selectTier(currentCard);
    });
  });

  // =========================================================================
  // Subnavigation Scroll-Spy & Active State Management
  // =========================================================================
  const subnavLinks = document.querySelectorAll('.tagebuch-subnav-link');
  const sections = ['angebot', 'tagebuch', 'details'].map(id => document.getElementById(id)).filter(Boolean);

  function setActiveSubnav(activeId) {
    subnavLinks.forEach(link => {
      const target = link.getAttribute('data-target') || (link.getAttribute('href') || '').replace('#', '');
      if (target === activeId) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'location');
      } else {
        link.classList.remove('is-active');
        link.removeAttribute('aria-current');
      }
    });
  }

  // Handle smooth click navigation
  subnavLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const targetId = link.getAttribute('data-target') || (link.getAttribute('href') || '').replace('#', '');
      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        e.preventDefault();
        setActiveSubnav(targetId);
        targetEl.scrollIntoView({ behavior: 'smooth' });
        if (history.pushState) {
          history.pushState(null, null, '#' + targetId);
        }
      }
    });
  });

  // Robust Scroll-Spy via IntersectionObserver
  if ('IntersectionObserver' in window && sections.length > 0) {
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSubnav(entry.target.id);
        }
      });
    }, observerOptions);

    sections.forEach(sec => observer.observe(sec));
  }
});
